import { render, staticRenderFns } from "./TrashedLists.vue?vue&type=template&id=00db11f2&"
import script from "./TrashedLists.vue?vue&type=script&lang=js&"
export * from "./TrashedLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports